import axios from "axios";
import useTokenManager from "@/composables/useTokenManager";
import {ref} from "vue";

// Load the API_URL from the .env file
const API_URL = process.env.API_URL || "";

// Get the WordPress nonce from the global scope
const wpNonce = ref(window.rbs_vr_object.nonce || "");

// Create an instance of axios with the base URL and common configurations
const api = axios.create({
    baseURL: API_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

// Request interceptor to handle common request tasks
api.interceptors.request.use(
    (config) => {
        const { token } = useTokenManager();
        config.headers.Authorization = `Bearer ${token.value}`;

        if(wpNonce.value) {
            // Add the WordPress nonce to the headers
            config.headers['X-WP-Nonce'] = wpNonce.value;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor to handle common response tasks
api.interceptors.response.use(
    (response) => {
        // Do something with the response data
        return response;
    },
    (error) => {
        // Handle common error scenarios
        return Promise.reject(error);
    }
);

export default api;
